<template>
  <div>
    <DetailPageLayout
      :breadcrumbItems="breadcrumbItems"
      :buttonItems="buttonItems"
    >
      <template #top>
        <BaseTabGroup
          ref="tab-group"
          :inputModel="formData"
          :inputComponents="inputComponents"
        ></BaseTabGroup>
      </template>
    </DetailPageLayout>
    <!-- 部署マスタモーダル -->
    <DepartmentModal
      id="department-modal"
      type="entry"
      :selectedSearchCondition="departmentModalSearchCondition"
      @after-close-set="afterCloseSetDepartment"
      @after-close-unset="afterCloseUnsetDepartment"
      @set-error-msg="setErrorMsg"
      @set-warn-msg="setWarnMsg"
    />
    <!-- 情報モーダル -->
    <InfoModal
      id="detail-info-modal"
      :columnInfos="messageInfo"
      :message="infoMessage"
      @after-close="back(obj)"
    />
    <!-- 登録モーダル -->
    <ConfirmModal
      id="register-modal"
      :columnInfos="messageInfo"
      :message="registerMessage"
      @confirm="register(obj)"
    />
  </div>
</template>

<script>
import RealVehicleInfo from './RealVehicleInfo'
import { getListOptions, openSubModal } from '@/common/Common.js'
import { SCREEN_ID, DEPARTMENT_KIND } from '@/common/const.js'
import {
  clear,
  goRegister,
  getBreadcrumbItems,
  back,
} from '@/common/screen-common.js'
import { init, register } from '@/master/realVehicle/RealVehicleDetail.js'

const screenId = SCREEN_ID.REAL_VEHICLE_DETAIL

export default {
  name: 'realVehicleDetail',
  components: {
    DepartmentModal: () => import('@/master/department/DepartmentModal.vue'),
  },
  props: {
    beforeScreenRouteInfo: {
      type: Object,
    },
    realVehicleId: {
      type: Number,
      default: -1,
    },
    screenKbn: {
      type: Number,
    },
  },

  data() {
    return {
      selectLonLat: null,
      formData: new RealVehicleInfo(),
      obj: this,
      registerMessage: null,
      oriData: new RealVehicleInfo(),
      departmentModalSearchCondition: {},
    }
  },

  created() {
    init(this)
  },

  computed: {
    detailCtrlInfo() {
      return this.$store.getters['init/getScreens'](screenId)(
        'detail_ctrl_info'
      )
    },
    detailInfo() {
      return this.$store.getters['init/getScreens'](screenId)('detail_info')
    },
    messageInfo() {
      return this.$store.getters['init/getScreens'](this.SCREEN_ID.COMMON)(
        'message'
      )
    },
    breadcrumbItems() {
      return getBreadcrumbItems(this.beforeScreenRouteInfo, screenId)
    },
    /**
     * ボタン情報リスト.
     * @return {Array}
     */
    buttonItems() {
      return [
        // ボタングループ#1
        [
          // 登録ボタン
          {
            variant: 'success',
            icon: 'edit',
            columnInfo: this.detailCtrlInfo.register,
            onClickCallback: () => {
              goRegister(this)
            },
          },
          // クリアボタン
          {
            variant: 'success',
            icon: 'times-circle',
            columnInfo: this.detailCtrlInfo.clear,
            onClickCallback: () => {
              clear(this)
            },
          },
          // 戻るボタン
          {
            variant: 'success',
            icon: 'times-circle',
            columnInfo: this.detailCtrlInfo.back,
            onClickCallback: () => {
              back(this)
            },
          },
        ],
        // ボタングループ#2
        [],
      ]
    },
    inputComponents() {
      return [
        {
          // 実車番情報タブ
          label: this.detailInfo.tab1.label,
          inputComponents: [
            {
              // 実車番ID
              type: 'text',
              id: 'realVehicleId',
              columnInfo: this.detailInfo.real_vehicle_id,
            },
            {
              // ブロックコード
              type: 'text',
              id: 'blockCode',
              columnInfo: this.detailInfo.block_code,
            },
            {
              // 運送会社
              type: 'referenceCodeName',
              codeId: 'carrierCode',
              nameId: 'carrierName',
              codeColumnInfo: this.detailInfo.carrier_code,
              nameColumnInfo: this.detailInfo.carrier_name,
              btnColumnInfo: this.detailInfo.sub_modal_carrier,
              codeRules: [this.INPUT_TYPE_CHECK.REQUIRED],
              nameRules: [this.INPUT_TYPE_CHECK.REQUIRED],
              onClickCallback: () => {
                this.departmentModalSearchCondition = {}
                this.departmentModalSearchCondition.departmentKind =
                  DEPARTMENT_KIND.CARRIER
                this.openSubModal(this, 'department-modal')
              },
            },
            {
              // 車番
              type: 'text',
              id: 'numberplate',
              columnInfo: this.detailInfo.numberplate,
              maxLength: 30,
              rules: [
                this.INPUT_TYPE_CHECK.REQUIRED,
                //this.INPUT_TYPE_CHECK.ALPHANUMERIC_CODE,
              ],
            },
            {
              // 区分（車両種類）
              type: 'select',
              id: 'realVehicleKind',
              columnInfo: this.detailInfo.real_vehicle_kind,
              options: getListOptions(this.MASTER_CODE.CARGO_VEHICLE_KIND),
              rules: [this.INPUT_TYPE_CHECK.REQUIRED],
              onChangeCallback: () => {},
            },
            {
              // 車型
              type: 'select',
              id: 'vehicleModel',
              columnInfo: this.detailInfo.vehicle_model,
              options: getListOptions(this.MASTER_CODE.VEHICLE_MODEL),
              onChangeCallback: () => {},
            },
            {
              // 備考
              type: 'text',
              id: 'note',
              columnInfo: this.detailInfo.note,
            },
            {
              // 実車番予備1
              type: 'text',
              id: 'reserve01',
              columnInfo: this.detailInfo.reserve_01,
              maxLength: 50,
            },
            {
              // 実車番予備2
              type: 'text',
              id: 'reserve02',
              columnInfo: this.detailInfo.reserve_02,
              maxLength: 50,
            },
            {
              // 実車番予備3
              type: 'text',
              id: 'reserve03',
              columnInfo: this.detailInfo.reserve_03,
              maxLength: 50,
            },
            {
              // 実車番予備4
              type: 'text',
              id: 'reserve04',
              columnInfo: this.detailInfo.reserve_04,
              maxLength: 50,
            },
            {
              // 実車番予備5
              type: 'text',
              id: 'reserve05',
              columnInfo: this.detailInfo.reserve_05,
              maxLength: 50,
            },
            {
              // 実車番予備6
              type: 'text',
              id: 'reserve06',
              columnInfo: this.detailInfo.reserve_06,
              maxLength: 50,
            },
            {
              // 実車番予備7
              type: 'text',
              id: 'reserve07',
              columnInfo: this.detailInfo.reserve_07,
              maxLength: 50,
            },
            {
              // 実車番予備8
              type: 'text',
              id: 'reserve08',
              columnInfo: this.detailInfo.reserve_08,
              maxLength: 50,
            },
            {
              // 実車番予備9
              type: 'text',
              id: 'reserve09',
              columnInfo: this.detailInfo.reserve_09,
              maxLength: 50,
            },
            {
              // 実車番予備10
              type: 'text',
              id: 'reserve10',
              columnInfo: this.detailInfo.reserve_10,
              maxLength: 50,
            },
            // {
            //   // 登録日時
            //   type: 'text',
            //   id: 'registrationTimeDisplay',
            //   columnInfo: this.detailInfo.registration_time_display,
            // },
            // {
            //   // 登録ユーザ
            //   type: 'text',
            //   id: 'registrationUser',
            //   columnInfo: this.detailInfo.registration_user,
            // },
            // {
            //   // 更新日時
            //   type: 'text',
            //   id: 'updateTimeDisplay',
            //   columnInfo: this.detailInfo.update_time_display,
            // },
            // {
            //   // 更新ユーザ
            //   type: 'text',
            //   id: 'updateUser',
            //   columnInfo: this.detailInfo.update_user,
            // },
            // {
            //   // バージョン
            //   type: 'text',
            //   id: 'version',
            //   columnInfo: this.detailInfo.version,
            // },
            // {
            //   // トリガ更新日時
            //   type: 'text',
            //   id: 'updateByTrigger',
            //   columnInfo: this.detailInfo.update_by_trigger,
            // },
          ],
        },
      ]
    },
    /**
     * 情報メッセージ.
     * @return {String}
     */
    infoMessage() {
      return this.$store.getters['init/getMessage'](
        'YZ00MG995I',
        this.detailCtrlInfo.register.label
      )
    },
  },

  methods: {
    getListOptions,
    openSubModal,
    register,
    back,

    /**
     * 部署マスタから取得データ設定
     */
    afterCloseSetDepartment(id, code, name) {
      this.formData.carrierId = id
      this.formData.carrierCode = code
      this.formData.carrierName = name
    },

    /**
     * 部署情報解除
     */
    afterCloseUnsetDepartment() {
      this.formData.carrierId = null
      this.formData.carrierCode = null
      this.formData.carrierName = null
    },

    setErrorMsg(msg) {
      this.$emit('set-error-msg', msg)
    },

    setWarnMsg(msg) {
      this.$emit('set-warn-msg', msg)
    },
  },

  // mounted() {
  //     this.$refs.map.initialize()
  // }
}
</script>

<style lang="scss" scoped>
.detailForm {
  height: 730px;
  overflow-y: auto;
  overflow-x: hidden;
}

#BaseView {
  height: 730px;
}
</style>
